import { render, staticRenderFns } from "./SearchProductCarousel.vue?vue&type=template&id=392d295f&scoped=true&"
import script from "./SearchProductCarousel.vue?vue&type=script&lang=js&"
export * from "./SearchProductCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SearchProductCarousel.vue?vue&type=style&index=0&id=392d295f&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392d295f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CenterSearchProduct: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/search/CenterSearchProduct.vue').default,SwiperNav: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/swiper-nav/SwiperNav.vue').default})
